import { Grid } from "@mui/material";
import DialogField from "modules/common/components/dialogField";
import { MAX_SHORTCUT_GROUP_NAME_LENGTH } from "modules/shortcuts/models";
import React from "react";
import DialogSkeleton from "./dialogSkeleton";
import TextFieldWithInputCounter from "modules/common/components/forms/inputs/textFieldWithInputCounter";

import "../../styles/shortcutGroupDialogSkeleton.sass";

interface IShortcutGroupDialogSkeletonProps {
    show: boolean;
    onClose: () => void;
    onDialogActionButtonClick: (groupName: string) => void;
    shortcutGroupName?: string;
    dialogTitle: string;
    dialogActionButtonLabel: string;
    dialogFieldLabel: string;
    extraDialogField?: JSX.Element;
    dialogPaperClassName?: string;
    disableActionButtonIfInputNotChanged?: boolean;
}

const ShortcutGroupDialogSkeleton: React.FC<IShortcutGroupDialogSkeletonProps> = ({
    show,
    onClose,
    onDialogActionButtonClick,
    shortcutGroupName = "",
    dialogTitle,
    extraDialogField,
    dialogFieldLabel,
    dialogActionButtonLabel,
    dialogPaperClassName,
    disableActionButtonIfInputNotChanged
}) => {
    const [previousInternalShortcutGroupName, setPreviousInternalShortcutGroupName] = React.useState<string>(shortcutGroupName);
    const [internalShortcutGroupName, setInternalShortcutGroupName] = React.useState<string>(shortcutGroupName);

    const isNotFilled = !internalShortcutGroupName.trim();

    const onDialogClose = () => {
        setInternalShortcutGroupName(shortcutGroupName);
        onClose();
    }

    const onDialogAction = () => {
        onDialogActionButtonClick(internalShortcutGroupName);
        setInternalShortcutGroupName(shortcutGroupName);
    }

    const getNameField = (): JSX.Element => 
        <TextFieldWithInputCounter
            value={internalShortcutGroupName}
            onChange={(e) => setInternalShortcutGroupName(e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
            multiline={false}
            inputProps={{ style: { fontSize: '1rem' }}}
            style={{ minHeight: 40 }}
            maxCount={MAX_SHORTCUT_GROUP_NAME_LENGTH}
        />;

    return <DialogSkeleton
        show={show}
        onClose={onDialogClose}
        onDialogActionButtonClick={onDialogAction}
        dialogTitle={dialogTitle}
        dialogActionButtonLabel={dialogActionButtonLabel}
        disableActionButton={disableActionButtonIfInputNotChanged !== undefined 
            ? isNotFilled || previousInternalShortcutGroupName === internalShortcutGroupName
            : isNotFilled
        }
        dialogPaperClassName={dialogPaperClassName}
    >
        <Grid 
            container
            alignItems={"center"}
            className="shortcut-group-dialog-body-grid-container"
        >
            {extraDialogField}
            <DialogField
                fieldName={dialogFieldLabel}
                fieldInput={getNameField()}
                labelWidth={4}
                mandatory
                fieldInputGridClassName="shortcut-group-dialog-name-input"
            />
        </Grid>
    </DialogSkeleton>;
};

export default ShortcutGroupDialogSkeleton;
